
export class RHCDeptModel {
    
    Id: any;
    DepartmentName: any;
    TypeCode: any;
    IsActive:any;
    
}